// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"302":"book-view","372":"home-view","855":"books-view"}[chunkId] + "." + {"302":"0587f314","372":"0587f314","855":"0587f314"}[chunkId] + ".chunk.css";
};